<template>
  <div id="index">
    <div class="statistic-row-box">
      <div class="column">
        <div class="tipT">用户总数(人)</div>
        <div :key="topStatistic.studentCount">
          {{ topStatistic.studentCount || 0 }}
        </div>
      </div>
      <div class="column">
        <div class="tipT">今日新增(人)</div>
        <div :key="topStatistic.newStudentCount">
          {{ topStatistic.newStudentCount || 0 }}
        </div>
      </div>
      <div class="column">
        <div>今日付费(人)</div>
        <div :key="topStatistic.newPayCount">
          {{ topStatistic.newPayCount || 0 }}
        </div>
      </div>
    </div>
    <div class="money-bar">
      <div class="four-block">
        <div class="items" style="margin-bottom: 15px">
          <div class="top">账户余额(元)</div>
          <div class="middle">{{ topStatistic.amount }}</div>
          <div class="bottom">
            本月消费
            <span>{{ consume1 ? Number(consume1).toFixed(2) : 0 }}</span>
          </div>
        </div>
        <div class="items">
          <div class="top">本月已售商品(个)</div>
          <div class="middle">{{ alSellCount }}</div>
          <!-- <div class="bottom">上月消费 <span>{{Number(sellConsume).toFixed(2)}}</span></div> -->
        </div>
        <div class="items">
          <div class="top">校区余额(元)</div>
          <div class="middle">{{ campusForm.amount }}</div>
          <div class="bottom">
            本月消费
            <span>{{ consume3 ? Number(consume3).toFixed(2) : 0 }}</span>
          </div>
        </div>
        <div class="items">
          <div class="top">校区总消费(元)</div>
          <div class="middle">
            {{
              campusForm.consumptionAmount
                ? campusForm.consumptionAmount.toFixed(2)
                : 0
            }}
          </div>
        </div>
      </div>
      <div class="notice-block" style="width: 400px">
        <div class="row jsb top-row">
          <div>考试动态</div>
          <div class="more"></div>
        </div>
        <div
          v-if="examActiveList.length"
          style="width: 100%"
          class="exam-active"
        >
          <div
            v-for="(item, index) in examActiveList"
            :key="item.id"
            :class="[{ todayActive: item.startTime == currentTime }]"
          >
            <div class="flex ai-fs">
              <div class="left">
                <div class="date">{{ item.startTime }}</div>
                <div class="today" v-if="item.startTime == currentTime">
                  今天
                </div>
              </div>
              <div class="center">
                <div class="dot"></div>
                <div
                  class="inline"
                  v-if="index != examActiveList.length - 1 || item.isCollage"
                ></div>
              </div>
              <div class="right">
                <div class="title" @click="goExamActive(item.title)">
                  {{ item.title }}
                  <el-tooltip effect="dark" placement="right">
                    <div slot="content" style="max-width: 400px">
                      {{ item.msgContent }}
                    </div>
                    <a class="more">查看</a>
                  </el-tooltip>
                </div>
                <div class="time">
                  {{ item.startTime }}-{{ item.endTime }}
                  <span
                    v-if="item.children.length > 0"
                    class="mission"
                    @click.stop="item.isCollage = !item.isCollage"
                    >{{
                      item.isCollage ? "收起" : `任务${item.children.length}`
                    }}</span
                  >
                </div>
              </div>
            </div>
            <template v-if="item.isCollage">
              <div
                class="flex ai-fs"
                v-for="(_item, _index) in item.children"
                :key="_item.id"
              >
                <div class="left">
                  <div class="date"></div>
                </div>
                <div class="center">
                  <div class="dot"></div>
                  <div
                    class="inline"
                    v-if="
                      _index != item.children.length - 1 ||
                      index != examActiveList.length - 1
                    "
                  ></div>
                </div>
                <div class="right">
                  <div class="title">
                    {{ _item.title }}
                    <el-tooltip effect="dark" placement="right">
                      <div slot="content" style="max-width: 400px">
                        {{ _item.msgContent }}
                      </div>
                      <a class="more">查看</a>
                    </el-tooltip>
                  </div>
                  <div class="time">
                    {{ _item.startTime }}-{{ _item.endTime }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <el-empty description="暂无数据" v-else></el-empty>
      </div>
      <div class="notice-block">
        <div class="row jsb top-row">
          <div>近期公告</div>
          <div class="more" @click="jumpMore">更多</div>
        </div>
        <div
          class="row items jsb"
          v-for="(item, index) in noticeList"
          :key="index"
          @click="jumpDetail(item.id)"
        >
          <div style="cursor: pointer">{{ item.title }}</div>
          <div>{{ item.createTime.substring(5, 10) }}</div>
        </div>
      </div>
    </div>
    <div class="chart-row jsb row">
      <div class="order-rank">
        <div class="title">商品本月下单TOP10</div>
        <el-table
          size="mini"
          ref="multipleTable"
          :data="topTenOrderArr"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%"
          border
        >
          <el-table-column align="center" prop="courseId" label="排名">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="商品名"
            width="300"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column align="center" prop="type" label="类型">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderCount"
            label="销量"
          ></el-table-column>
        </el-table>
      </div>
      <div class="order-chart">
        <div class="chart-titleRow row jsb">
          <div class="title">商品本月下单TOP10</div>
          <div class="row switch-react">
            <div :class="orderAc == 0 ? 'active' : ''" @click="switchOrder(0)">
              近6月
            </div>
            <div :class="orderAc == 1 ? 'active' : ''" @click="switchOrder(1)">
              近12月
            </div>
          </div>
        </div>
        <div id="orderchart" :style="{ width: '100%', height: '350px' }"></div>
      </div>
    </div>
    <div class="chart-row jsb row">
      <div class="order-rank">
        <div class="title">今日课程学习TOP10</div>
        <el-table
          size="mini"
          ref="multipleTable"
          :data="productRank"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="courseId"
            label="排名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="questionTypeId"
            label="课程名"
            width="300"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            prop="title"
            label="类型"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="answer"
            label="学习人数"
          ></el-table-column>
        </el-table>
      </div>
      <div class="order-chart">
        <div class="chart-titleRow row jsb">
          <div class="title">最近7天学习人数</div>
        </div>
        <div id="studyChart" :style="{ width: '100%', height: '350px' }"></div>
      </div>
    </div>
    <div class="chart-row jsb row">
      <div class="order-rank">
        <div class="title">答疑排行榜</div>
        <el-table
          ref="multipleTable"
          :data="page.rows"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%"
          border
          rowClassName="table-list"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column show-overflow-tooltip width="60" label="排行">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="area"
            label="所属校区"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="userName"
            label="老师"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="questionAnsweringNum"
            label="回复个数"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="count"
            label="点赞数"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="time"
            label="平均回复时间"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <router-link :to="{path: '/successfulCandidates'}">成考学员</router-link>
    <router-link :to="{path: '/nlineTeachingStudents'}">网教学员</router-link>
    <router-link :to="{path: '/selfTaughtStudents'}">自考学员</router-link>
    <router-link :to="{path: '/nonAcademicStudents'}">非学历学员</router-link>
    <router-link :to="{path: '/editDetails'}">详情</router-link>
    <router-link :to="{path: '/studentExamination'}">学员考试</router-link>
    <router-link :to="{path: '/enterScore'}">录入成绩</router-link>
    <router-link :to="{path: '/auditCenter'}">入职审批</router-link>
    <router-link :to="{path: '/eduProcedure'}">教务流程</router-link>
    <router-link :to="{path: '/subjectCourseManage'}">科目课程</router-link>
    <router-link :to="{path: '/addProcess'}">添加流程</router-link> -->
    <!-- <router-link :to="{path: '/officialAccount'}">二维码</router-link> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  data() {
    return {
      consume3: 0,
      Loading: false,
      campusForm: {},
      alSellCount: 0,
      sellConsume: 0,
      consume1: 0,
      campusAmount: 0,
      topTenOrderArr: [],
      topStatistic: {},
      noticeList: [],
      agentInfo: {},
      title: "",
      productRank: null,
      user: JSON.parse(localStorage.getItem("user")) || {},
      nowDate: "",
      company: "",
      usersss: {},
      note: [
        {
          title:
            "职业资格、自考课程及题库更新公告职业资格、自考课程及题库更新公告职业资格、自考课程及题库更新公告",
          time: "10-21",
        },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
        { title: "职业资格、自考课程及题库更新公告", time: "10-21" },
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      searchForm: {
        pageSize: 10,
        pageNumber: 1,
      },
      orderAc: 0,
      orderCategory: ["1", "2", "3", "4", "5", "6", "7"],
      orderData: [],
      studyXray: [],
      studyData: [50, 606, 90, 1, 20, 40],
      examActiveList: [],
      currentTime: "",
    };
  },
  created() {},
  mounted() {
    this.studyXray = [];
    var count = 0;
    for (var i = 0; i <= 6; i++) {
      this.studyXray.push(this.getDateTime(count));
      count = count - 0.5;
    }
    // this.getTimes();
    this.applicationTrendsList();
    this.getCampusInfo();
    this.getAgentInfo();
    this.getTopTenOrder();
    this.getNoticeList();
    this.getOrderChart(() => {
      this.drawOrderchart();
    });
    this.drawStudyChart();
    this.getConsume(3);
    this.getConsume(1, "消费");
    var Nowdate = new Date();
    var vYear = Nowdate.getFullYear();
    var vMon = Nowdate.getMonth() + 1;
    var params = {
      beginTime: vYear + "-" + vMon + "-1" + " 00:00:00",
      endTime:
        vYear + "-" + vMon + "-" + this.getCurrentMonthLast() + " 00:00:00",
    };
    this.api.agentInfo.getAlreadySellCounts(params).then((res) => {
      this.alSellCount = res.data;
    });
    this.loadQuizRank();
  },
  methods: {
    jumpMore() {
      this.$router.push("/newsList");
      console.log(789789789);
    },
    jumpDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: id,
        },
      });
    },
    formatSeconds(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = "";
      if (h !== "00") res += `${h}h`;
      if (m !== "00") res += `${m}min`;
      res += `${s}s`;
      return res;
    },
    applicationTrendsList() {
      let now = new Date();
      this.currentTime = this.getDateStr(new Date());
      this.api.exam
        .applicationTrendsList({
          pageSize: 100,
          pageNo: 1,
          startTime: this.getDateStr(
            new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
          ),
          endTime: this.getDateStr(
            new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
          ),
          column: "start_time",
          order: "desc",
          isDelete: 0,
        })
        .then((res) => {
          res.result.records.forEach((item) => {
            item.isCollage = false;
          });
          this.examActiveList = res.result.records;
        });
    },
    getDateStr(now) {
      var year = now.getFullYear(); // 年
      var month = now.getMonth() + 1; // 月
      var day = now.getDate(); // 日
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month + "-" + day;
    },
    loadQuizRank() {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.agentInfo
        .quizRankList(this.searchForm)
        .then((result) => {
          console.log(result, "88888");
          result.data.records.forEach((v) => {
            v.avgAnswerTime = this.formatSeconds(v.avgAnswerTime);
          });
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.Loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCurrentMonthLast() {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return day;
    },
    getConsume(num, type) {
      var Nowdate = new Date();
      var vYear = Nowdate.getFullYear();
      var vMon = Nowdate.getMonth() + 1;
      console.log(this.getCurrentMonthLast(), "getXonsume");
      this.api.agentInfo
        .getCammpusConsume({
          objectType: num,
          type: "消费",
          beginTime: vYear + "-" + vMon + "-1" + " 00:00:00",
          endTime:
            vYear + "-" + vMon + "-" + this.getCurrentMonthLast() + " 00:00:00",
        })
        .then((res) => {
          if (num == 1) {
            this.consume1 = res.data.consumptionAmount;
          } else {
            this.consume3 = res.data.consumptionAmount;
            // this.sellConsume = res.data.consumptionAmount
          }
        });
    },
    getOrderChart(callback) {
      var Nowdate = new Date();
      var minusNum = this.orderAc == 0 ? 6 : 12;
      var vYear = Nowdate.getFullYear();
      var eYear = Nowdate.getFullYear();
      var vMon = Nowdate.getMonth() + 1;
      var monArr = [];
      for (var i = 0; i < 12; i++) {
        monArr.push(i + 1);
      }
      monArr = monArr.reverse();
      if (vMon - minusNum < 1) {
        eYear--;
        console.log("88", monArr, monArr[Math.abs(vMon - minusNum)]);
      }
      this.api.agentInfo
        .getListByDateChart({
          beginTime:
            eYear +
            "-" +
            (vMon - minusNum < 1
              ? monArr[Math.abs(vMon - minusNum)]
              : vMon - minusNum) +
            "-1",
          endTime: vYear + "-" + vMon + "-1",
        })
        .then((res) => {
          if (res.success) {
            this.orderData = res.data.goodsInfoList;
            var dateArr = [];
            res.data.dateList.forEach((v) => {
              dateArr.push(v.substring(0, 10));
            });
            this.orderCategory = dateArr;
            console.log(res.data.dateList, "89999");
            callback && callback();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    switchOrder(num) {
      this.orderAc = num;
      this.getOrderChart(() => {
        this.drawOrderchart();
      });
    },
    getDateTime(val) {
      var dd = new Date();
      let AddDayCount = val; //0.5为一天
      dd.setTime(dd.getTime() + AddDayCount * 24 * 60 * 60 * 1000);
      return (
        dd.setTime(dd.getTime() + AddDayCount * 24 * 60 * 60 * 1000),
        dd.getFullYear() + "-" + (dd.getMonth() + 1) + "-" + dd.getDate()
      );
    },
    drawStudyChart() {
      console.log("123999999999");
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("studyChart"));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: "category",
          data: this.studyXray,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.studyData,
            type: "line",
          },
        ],
      });
    },
    drawOrderchart() {
      console.log("drawFinish", "dasd");
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("orderchart"));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: "category",
          data: this.orderCategory,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.orderData,
            type: "line",
          },
        ],
      });
      myChart.resize();
      console.log("drawFinish");
    },
    getAgentInfo() {
      this.api.agentInfo.getIndexAgentInfo().then((res) => {
        if (res.success) {
          console.log("getAgentInfo", res.data);
          this.topStatistic = res.data;
          this.topStatistic = { ...res.data };
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getNoticeList() {
      this.api.agentInfo
        .getTopTenNotice({
          pageSize: 10,
          pageNumber: 1,
          orderBy: "create_time",
        })
        .then((res) => {
          if (res.success) {
            this.noticeList = res.data.records;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getTopTenOrder() {
      var Nowdate = new Date();
      var vYear = Nowdate.getFullYear();
      var vMon = Nowdate.getMonth() + 1;
      var params = {
        beginTime: vYear + "-" + vMon + "-1",
        endTime: vYear + "-" + vMon + "-" + this.getCurrentMonthLast(),
      };
      this.api.agentInfo.getListByOrder(params).then((res) => {
        if (res.success) {
          this.topTenOrderArr = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getCampusInfo() {
      this.api.campus.getCampusInfo().then((result) => {
        this.campusForm = result.data;
      });
    },
    getTimes() {
      let now = new Date();
      let hour = now.getHours();
      if (hour < 6) {
        this.nowDate = "凌晨好";
      } else if (hour < 9) {
        this.nowDate = "早上好";
      } else if (hour < 12) {
        this.nowDate = "上午好";
      } else if (hour < 14) {
        this.nowDate = "中午好";
      } else if (hour < 17) {
        this.nowDate = "下午好";
      } else if (hour < 19) {
        this.nowDate = "傍晚好";
      } else if (hour < 22) {
        this.nowDate = "晚上好";
      } else {
        this.nowDate = "夜里好";
      }
    },
  },
};
</script>
<style lang="css" scoped>
.exam-active >>> .el-tooltip__popper {
  max-width: 400px;
}
</style>
<style lang="less" scoped>
#index {
  width: 100%;
  height: 100%;
  .statistic-row-box {
    height: 120px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background: white;
    .column {
      display: flex;
      flex-direction: column;
      text-align: center;
      div {
        &:first-child {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 15px;
          text-align: center;
          color: #a2aabc;
        }
        &:last-child {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 28px;
          text-align: center;
          margin-top: 15px;
          color: #455a64;
        }
      }
    }
  }
  .money-bar {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    justify-content: space-between;
    .four-block {
      display: flex;
      width: calc(100% - 700px);
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .items {
        flex-shrink: 0;
        width: 49.3%;
        height: 160px;
        background: white;
        div {
          text-align: center;
        }
        .top {
          text-align: center;
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 15px;
          color: #a2aabc;
          text-align: center;
          margin-top: 25px;
        }
        .middle {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 28px;
          margin: 15px 0;
          color: #455a64;
          text-align: center;
        }
        .bottom {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          text-align: center;
          span {
            font-family: "微软雅黑";
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }
    .notice-block {
      width: 300px;
      margin-left: 15px;
      height: 334px;
      flex-shrink: 0;
      background: white;
      flex-grow: 1;
    }
    .exam-active {
      margin-top: 3px;
      height: calc(100% - 20px);
      overflow-y: scroll;

      .more {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        color: #4d94ff;
        text-align: right;
        cursor: pointer;
      }
      .flex {
        display: flex;
        align-items: center;
      }
      .jc-sb {
        justify-content: space-between;
        div {
          cursor: pointer;
          border-bottom: 2px solid #fff;
        }
        .active {
          border-bottom: 2px solid rgb(0, 118, 255);
          color: rgb(0, 118, 255);
        }
      }
      .ai-fs {
        align-items: flex-start !important;
      }
      .list {
        padding: 20px;
        box-sizing: border-box;
        height: 700px;
        overflow-y: scroll;
      }
      .todayActive {
        div {
          color: rgb(0, 118, 255) !important ;
        }
        .dot {
          background: rgb(0, 118, 255) !important ;
        }
      }
      .left {
        .date {
          width: 100px;
          text-align: center;
          font-size: 14px;
          color: rgb(182, 173, 173);
        }
        .today {
          width: 44px;
          color: #fff !important;
          background: rgb(111, 153, 201);
          padding: 4px 0;
          font-size: 12px;
          border-radius: 4px;
          text-align: center;
          margin: 6px auto 0;
        }
      }
      .center {
        margin: 0 8px;
        .dot {
          width: 16px;
          height: 16px;
          background: rgb(225, 227, 235);
          border-radius: 20px;
        }
        .inline {
          margin: 0 auto;
          width: 2px;
          height: 60px;
          background: rgb(225, 227, 235);
        }
      }
      .right {
        width: 300px;

        .title {
          font-size: 14px;
          color: #000;
          cursor: pointer;
          a {
            margin-left: 8px;
          }
        }
        .time {
          margin-top: 10px;
          font-size: 14px;
          color: rgb(182, 173, 173);
        }
        .mission {
          cursor: pointer;
          background: #4e9aee;
          padding: 4px 8px;
          border-radius: 16px;
          font-size: 12px;
          color: #fff;
        }
      }
    }
  }
  .row {
    display: flex;
    flex-direction: row;
  }
  .jsb {
    justify-content: space-between;
  }
  .column {
    display: flex;
    flex-direction: column;
  }
  .notice-block {
    padding: 15px 10px 10px;
    box-sizing: border-box;
    .items {
      line-height: 30px;
      div {
        &:last-child {
          color: #a2aabc;
        }
      }
    }
    .top-row {
      .more {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        color: #4d94ff;
        text-align: right;
        cursor: pointer;
      }
    }
  }
  .chart-row {
    margin-top: 15px;
    .title {
      font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
    }
    .order-rank {
      width: 49.5%;
      background: white;
      height: 440px;
      box-sizing: border-box;
      padding: 15px 10px 10px;
    }
    .order-chart {
      padding: 15px 10px 10px;
      box-sizing: border-box;
      width: 49.5%;
      height: 440px;
      background: white;
      .switch-react {
        div {
          width: 60px;
          height: 24px;
          background: inherit;
          box-sizing: border-box;
          align-items: center;
          display: flex;
          justify-content: center;
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          color: #455a64;
          cursor: pointer;
          border: 1px solid rgba(238, 238, 238, 1);
        }
        .active {
          color: white;
          border: 0;
          background: rgba(77, 148, 255, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/index.vue